import React, { useContext, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Card, Col, Row } from 'react-bootstrap';
import { Icon, IconButton, Link, OverflowSet } from '@fluentui/react';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { __onGoToBoardContract, __onGoToBoardEP, __onGoToBoardKpiOperational, __onGoToBook, __onGoToElementObligationAchives, __onGoToObligationControl } from '../../../../../../common/SystemRedirections';
import { getGridLocalization, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import './style.css'
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import i18next from 'i18next';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { action_setBoardContractFilterComponents_And_Sync_Flag, action_setPageState } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useGetContractsPropsMaintainer } from '../../../../../../hooks/services/sBook/useOfContract';
import { __OBJECT_STRUCTURE_BoardFilters } from '../../../../../../common/ObjectStructures/sKPI';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { enum__PRIVILEGE_APP } from '../../../../../../common/Dictionaries';
import MainAppContext from '../../../../../../MainAppContext';
function ELEMENT_CONTRACT_KPI_DETAIL(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { 
      inputParam_HideHeader = false,
      inputParam_ComponentContent = null,
      inputParam_UseFake = false,
      inputParam_BoardStructure = null,
      inputParam_Container = null,
  } = props;

  const { _contractProps: listContractsProps } = useSelector((state) => state.maintainerScope);
  const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);
  const { _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled } = useSelector((state) => state.boardViewComponentsScope);
  
  const contextSite = useContext(MainAppContext);

  const gridRef = useRef();

  const _dynamicColumns = !inputParam_UseFake ? inputParam_ComponentContent?.item?.dynamic_cols : [];
  const _data = !inputParam_UseFake ? inputParam_ComponentContent?.item?.contracts.map(contract => {
    _dynamicColumns.forEach(column => {
      const itemValues = contract.l_props.find(x => x.contractPropId === column.id)
      contract[column.shortName] = !isNullUndefinedOrEmpty(itemValues) ? (itemValues.strVal ?? itemValues.numVal ?? itemValues.cplVal) : "";
    });

    return contract;
  }): [];

  //const [firstLoad, setFirstLoad] = useState(false);
  const [data, setData] = useState(_data);
  const [filtredData, setFiltredData] = useState(_data)
  const [syncronized, setSyncronized] = useState(null)
  const [filterText, setFilterText] = useState(boardContractFilterOfComponents.filter_text)

  useGetContractsPropsMaintainer(listContractsProps);

  const handlerCellClick = (event) => {
    if (event.args.datafield !== 'elementId') {
      const rowIndex = event.args.rowindex;
      const rowData = event.args.owner.getrowdata(rowIndex);
      __onGoToBoardContract(rowData.elementId, history)      
    }
  };

  const getDataFields = () => {
    const basicDataFields = [
      { name: 'elementId',           type: 'string' },
      { name: 'contractCode',        type: 'string' },
      { name: 'name',                type: 'string' },                              
      { name: 'currency',            type: 'string' },
      { name: 'amount',              type: 'number' },
      { name: 'legalEntityBuyer',    type: 'string' },
      { name: 'businessUnit',        type: 'string' },
      { name: 'legalEntitySupplier', type: 'string' },
      { name: 'category',            type: 'string' },
      { name: 'segment',             type: 'string' },
      { name: 'endowment',           type: 'number' },
      { name: 'status',              type: 'string' },
      { name: 'startDate',           type: 'date'   },
      { name: 'endDate',             type: 'date'   },
      { name: 'scope',               type: 'string' },
    ]

    const dynamicDataFields = listContractsProps.map(column => {
      let type = "string";

      if (_data.length > 0) {    
        if (column.valType === "str") {
          type = "string"
        }
        else if (column.valType === "num") {
          type = "number"
        }
        else if (column.valType === "list") {
          type = "string"
        }
        else {
          type = "string"
        }
      }

      const object = { name: column.shortName, type: type };
      return object;
    });
    const finalDataFields = basicDataFields.concat(dynamicDataFields);

    return finalDataFields
  }

  const onRenderOverflowButton = (overflowItems) => {
    const buttonStyles = {
      root: {
        minWidth: 0,
        padding: '0 4px',
        alignSelf: 'stretch',
        height: 'auto',
      },
    };
    return (
      <IconButton
        title="More options"
        styles={buttonStyles}
        menuIconProps={{ iconName: 'More' }}
        menuProps={{ items: overflowItems }}
      />
    );
  };

  const onRenderItem = (item) => {
    return (
      <Link styles={{ root: { marginRight: 10 } }} onClick={item.onClick}>
        {item.name}
      </Link>
    );
  };

  const actionCellsRenderer2 = (itemId) => {
    const grid = gridRef.current;
    const idx = grid?.getrowboundindexbyid(itemId);
    const rowData = idx >= 0 ? grid?.getrowdata(idx) : null;

    return (
      <Row>
          <Col>
            <OverflowSet
              aria-label="Estado de pago"
              overflowItems={[
                {
                  key: 'item1',
                  name: 'Control de obligaciones',
                  onClick: undefined,
                },
                {
                  key: 'item2',
                  name: 'Book',
                  onClick: undefined,
                },
              ]}
              onRenderOverflowButton={onRenderOverflowButton}
              onRenderItem={onRenderItem}
              overflowSide={'start'}
            />
          </Col>
      </Row>
    );
  };

  const getRowIdFromRowIndex = (rowIndex) => {
      if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
          return filtredData[rowIndex.boundindex];
      }
      return filtredData[rowIndex];
  };

  const actionCellsRenderer = (objSource) => {
    const rowData = getRowIdFromRowIndex(objSource)

    return (
      

      <div className='d-flex'>
          { 
            !isNullUndefined(rowData) && !isNullUndefined(rowData.bookId) && !isNullUndefined(contextSite.securityProps.l_products.find(product => product.toLowerCase() === enum__PRIVILEGE_APP.BOOK.toLowerCase())) &&
            <IconButton title={t('data-lang-lbl-book')} styles={{root: {color: "#16C2D0 "}}} iconProps={{iconName: "PublishCourse"}} onClick={() => __onGoToBook(rowData.bookId)} />
          }
          {
            (isNullUndefined(rowData) || isNullUndefined(rowData.bookId) || isNullUndefined(contextSite.securityProps.l_products.find(product => product.toLowerCase() === enum__PRIVILEGE_APP.BOOK.toLowerCase()))) &&
            <IconButton title={t('data-lang-lbl-book')} styles={{root: {color: "#16C2D0 "}}} iconProps={{iconName: "PublishCourse"}} disabled={true} />
          }

          {
            !isNullUndefined(rowData) && !isNullUndefined(contextSite.securityProps.l_products.find(product => product.toLowerCase() === enum__PRIVILEGE_APP.CO.toLowerCase())) &&
            <IconButton title={t('data-lang-lbl-co-long')} styles={{root: {color: "#f24656"}}} iconProps={{iconName: "Trackers"}} onClick={() => __onGoToElementObligationAchives(rowData.elementId, 1)} />
          }
          {
            (isNullUndefined(rowData) || isNullUndefined(contextSite.securityProps.l_products.find(product => product.toLowerCase() === enum__PRIVILEGE_APP.CO.toLowerCase()))) &&
            <IconButton title={t('data-lang-lbl-co-long')} styles={{root: {color: "#f24656"}}} iconProps={{iconName: "Trackers"}} disabled={true} />
          }

          {
            !isNullUndefined(rowData) && !isNullUndefined(contextSite.securityProps.l_products.find(product => product.toLowerCase() === enum__PRIVILEGE_APP.EDP.toLowerCase())) &&
            <IconButton title={t('data-lang-lbl-edps')} styles={{root: {color: "#ff8f29"}}} iconProps={{iconName: "AllCurrency"}} onClick={() => __onGoToBoardEP(rowData.elementId)} />
          }
          {
            (isNullUndefined(rowData) || isNullUndefined(contextSite.securityProps.l_products.find(product => product.toLowerCase() === enum__PRIVILEGE_APP.EDP.toLowerCase()))) &&
            <IconButton title={t('data-lang-lbl-edps')} styles={{root: {color: "#ff8f29"}}} iconProps={{iconName: "AllCurrency"}} disabled={true} />
          }
          <IconButton title={t('data-lang-lbl-kpi')} styles={{root: {color: "#115e8c"}}} iconProps={{iconName: "Financial"}} onClick={() => __onGoToBoardKpiOperational(rowData.elementId, 4)} />
      </div>
    );
  };

  const getColumns = () => {
    const basicColumns = [
      { index: null, text: t('data-lang-lbl-modules'),      datafield: 'elementId',           uploadMasive: false, exportable: false, width: '135px', columntype: 'textbox', editable: false, pinned: true,
        createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
        initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
      },
      { index: null, text: t('data-lang-lbl-code'),         datafield: 'contractCode',        uploadMasive: true,  exportable: true,  width: '150px', columntype: 'textbox', editable: false, pinned: true },
      { index: 0,    text: t('data-lang-lbl-name'),         datafield: 'name',                uploadMasive: true,  exportable: true,  width: '200px', columntype: 'textbox', editable: false, pinned: true },
      { index: 1,    text: t('data-lang-lbl-currency'),     datafield: 'currency',            uploadMasive: true,  exportable: true,  width: '100px', columntype: 'textbox', editable: false },
      { index: 2,    text: t('data-lang-lbl-amount'),       datafield: 'amount',              uploadMasive: true,  exportable: true,  width: '175px', columntype: 'textbox', editable: false, cellsformat: 'c2', cellsalign: 'right' },
      { index: 3,    text: t('data-lang-lbl-buyer'),        datafield: 'legalEntityBuyer',    uploadMasive: true,  exportable: true,  width: '200px', columntype: 'textbox', editable: false },
      { index: 4,    text: t('data-lang-lbl-businessunit'), datafield: 'businessUnit',        uploadMasive: true,  exportable: true,  width: '200px', columntype: 'textbox', editable: false },
      { index: 5,    text: t('data-lang-lbl-supplier'),     datafield: 'legalEntitySupplier', uploadMasive: true,  exportable: true,  width: '200px', columntype: 'textbox', editable: false },
      { index: 6,    text: t('data-lang-lbl-category'),     datafield: 'category',            uploadMasive: true,  exportable: true,  width: '100px', columntype: 'textbox', editable: false },
      { index: 7,    text: t('data-lang-lbl-segment'),      datafield: 'segment',             uploadMasive: true,  exportable: true,  width: '100px', columntype: 'textbox', editable: false },
      { index: 8,    text: t('data-lang-lbl-endowment'),    datafield: 'endowment',           uploadMasive: true,  exportable: true,  width: '100px', columntype: 'textbox', editable: false, cellsformat: 'n2', cellsalign: 'right' },
      { index: 9,    text: t('data-lang-lbl-status'),       datafield: 'status',              uploadMasive: true,  exportable: true,  width: '150px', columntype: 'textbox', editable: false },
      { index: 10,   text: t('data-lang-lbl-startdate'),    dataField: 'startDate',           uploadMasive: true,  exportable: true,  width: '200px', columntype: 'datetimeinput',  editable: false, cellsformat: 'dd-MM-yyyy' },
      { index: 11,   text: t('data-lang-lbl-enddate'),      dataField: 'endDate',             uploadMasive: true,  exportable: true,  width: '200px', columntype: 'datetimeinput',  editable: false, cellsformat: 'dd-MM-yyyy' },
      { index: 12,   text: t('data-lang-lbl-scope'),        dataField: 'scope',               uploadMasive: true,  exportable: true,  width: '200px', columntype: 'textbox', editable: false },
    ]

    let maxIndex = basicColumns.reduce((max, item) => {
      return item.index > max ? item.index : max;
    }, 0);

    const dynamicColumns = listContractsProps.map(column => {
      let columntype = "textbox"
      if (_data.length > 0) {

        if (column.valType === "str") {
          columntype = "textbox"
        }
        else if (column.valType === "num") {
          columntype = "textbox"
        }
        else if (column.valType === "list") {
          columntype = "textbox"
        }
        else {
          columntype = "textbox"
        }
      }

      const object = { index: maxIndex, text: column.name, datafield: column.shortName, uploadMasive: false,  exportable: true,  width: '100px', columntype: columntype,  editable: false };
      maxIndex = maxIndex + 1;
      
      return object
    });

    const finalColumns = basicColumns.concat(dynamicColumns);

    return finalColumns;
  }

  const renderContent = () => {
    return 	<>
        {
          data && listContractsProps &&
          <Row className='h-100' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
            <Col>
              <JqxGrid
                  altrows={true}
                  ref={gridRef}
                  enabletooltips={true}
                  width={'100%'}
                  className='jqx-custom-grid'
                  theme={'light'} 
                  height={'100%'}
                  pagesize={20}
                  editable={false}
                  pageable={true}
                  sortable={true}
                  filterable={true}
                  showfilterrow={false} 
                  localization={getGridLocalization(t)}
                  source={ new jqx.dataAdapter({
                      localData: filtredData,
                      dataType: 'array',
                      dataFields: getDataFields(),
                      id: 'elementId'
                  })}
                  columns={getColumns()}
                  onCellclick={handlerCellClick}
              />
            </Col>
          </Row>
        }
    </>
  }

  const handlerSetTextValue = (e) => {
    const searchText = e.target.value;
    setFilterText(searchText);
  }

  const handlerFilterListContract = () => {
    if (!filterText) {
        setFiltredData(data)
    } else {
        const _filteredData = data.filter(item => 
            Object.values(item).some(value => 
                value?.toString().toLowerCase().includes(filterText.toLowerCase())
            )
        );
        setFiltredData(_filteredData)
    }
    setSyncronized(false)
    gridRef.current.updatebounddata('filter');
  }

  const handlerClearFilter = () => {
    setFiltredData(data)
    setFilterText("");
    gridRef.current.updatebounddata('filter');
    
    dispatch(action_setPageState(false));
    dispatch(action_setBoardContractFilterComponents_And_Sync_Flag(__OBJECT_STRUCTURE_BoardFilters(), false));
    setSyncronized(null)
  }

  const handlerApplyFilters = () => {
    boardContractFilterOfComponents.contractFilterList = getAppliedFilters();
    boardContractFilterOfComponents.l_codes = gridRef.current.getdisplayrows().map(x => x.contractCode);
    boardContractFilterOfComponents.filter_type = "contract";
    boardContractFilterOfComponents.filter_text = filterText;
    
    dispatch(action_setPageState(false));
    dispatch(action_setBoardContractFilterComponents_And_Sync_Flag(boardContractFilterOfComponents, false));
    setSyncronized(true)
  }

  const handlerApplyPrevFilters = () => {
    boardContractFilterOfComponents.contractFilterList = getAppliedFilters();
    boardContractFilterOfComponents.l_codes = gridRef.current.getdisplayrows().map(x => x.contractCode);
    boardContractFilterOfComponents.filter_type = "contract";
    boardContractFilterOfComponents.filter_text = getContractFiltersPrevData();
    
    dispatch(action_setPageState(false));
    dispatch(action_setBoardContractFilterComponents_And_Sync_Flag(boardContractFilterOfComponents, false));
    setFilterText(boardContractFilterOfComponents.filter_text)
    setSyncronized(true)
  }
  
  const getAppliedFilters = () => {
    const filterInfo = gridRef.current.getfilterinformation();
    const filterList = filterInfo.map(fi => ({
        columna: fi.filtercolumntext,
        condicion: fi.filter.getfilters()[0].condition,
        valor: fi.filter.getfilters()[0].value
    }));

    return filterList;
  }

  const getContractFiltersPrevData = () => {
    const value = window.localStorage.getItem('contract-syncronized')

    if (isNullUndefinedOrEmpty(value)) {
      return false
    }
    else {
      return value !== ""
    }
  }

  /*useEffect(() => {
      function doIt() {
        setFirstLoad(true);

        handlerFilterListContract();
      }

      if (firstLoad === false && data && listContractsProps) {
        doIt()
      }

  }, [firstLoad,  data, listContractsProps]);*/
  
  return (
  <>
  {
    !inputParam_UseFake &&
    <Card className='h-100 pb-2'>
              {
                  !inputParam_HideHeader &&
                  <Card.Header className="card-header-compact">
                      <Card.Title className="d-flex justify-content-between">
                        <b>{(!inputParam_UseFake && inputParam_ComponentContent !== null) ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-contracts')) : t('data-lang-boxname-contracts')}</b>
                          <div className='toolbar d-flex'>
                            <HEADER_TOOLBAR
                              inputParam_BoardStructure={inputParam_BoardStructure}
                              inputParam_Container={inputParam_Container}
                            />
                            <div className='d-flex'>
                              <div className='px-0 mx-0 my-auto d-flex'>
                                {
                                  filterText !== "" &&
                                  <IconButton iconProps={{iconName: "Clear"}} onClick={handlerClearFilter} />
                                }
                                <IconButton iconProps={{iconName: "Search"}} onClick={handlerFilterListContract} />
                              </div>
                              <div className='px-1 mx-0 my-auto'>
                                <input
                                  type="text"
                                  placeholder={t('data-lang-btn-search') + "..."}
                                  style={{fontSize: '16px'}}
                                  value={filterText}
                                  onChange={handlerSetTextValue}
                                />
                              </div>
                              <div className='px-2 mx-0 my-auto pt-1'>
                                {
                                  !isNullUndefinedOrEmpty(syncronized) &&
                                  <>
                                    <IconButton
                                      style={{ fontFamily: "FabricMDL2Icons", color: (syncronized ? "blue" : "red") }}
                                      iconProps={{iconName: (syncronized ? "SyncOccurence" : "UnsyncOccurence")}}
                                      onClick={handlerApplyFilters}
                                    />
                                    {
                                       getContractFiltersPrevData() &&
                                       <IconButton
                                          style={{ fontFamily: "FabricMDL2Icons", color: "green" }}
                                          iconProps={{iconName: "ReturnToSession"}}
                                          onClick={handlerApplyPrevFilters}
                                        />
                                    }
                                  </>
                                }
                                {
                                  isNullUndefinedOrEmpty(syncronized) &&
                                    <Icon style={{ fontFamily: "FabricMDL2Icons", color: "grey" }} iconName={"SyncOccurence"} />
                                }
                              </div>
                            </div> 
                          </div>
                      </Card.Title>
                  </Card.Header>
              }
              <Card.Body className='px-1 py-0 h-100'>
              {renderContent()}
              </Card.Body>
          </Card>
  }
  {
    inputParam_UseFake && renderContent()
  }
  </>
  );
}

ELEMENT_CONTRACT_KPI_DETAIL.propTypes = {
  inputParam_HideHeader: PropTypes.bool.isRequired,
  inputParam_ComponentContent: PropTypes.object,
};

export default ELEMENT_CONTRACT_KPI_DETAIL;